import { useState } from "react";
import { Link } from "react-router-dom";
import { MixCover } from "./MixCover";
import { mixService } from "@/services/mixService";
import { usePlayer } from "@/hooks/usePlayer";
import { sfx } from "@/lib/sfx";
import type { MixSummary } from "@/types/types";

export function MixCard({ mix }: { mix: MixSummary }) {
  const player = usePlayer();
  const [busy, setBusy] = useState(false);

  const playNow = async (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
    if (busy) return;
    setBusy(true);
    sfx.pop();
    try {
      const m = await mixService.get(mix.id);
      if (m.tracks.length) await player.play(m.tracks, 0);
    } catch (err) {
      console.warn("mix play failed", err);
    } finally { setBusy(false); }
  };

  return (
    <Link to={`/mix/${mix.id}`} className="card mix-card" data-sfx="tap" style={{ display: "block" }}>
      <div style={{ position: "relative" }}>
        <MixCover mix={mix} />
        <button className="mix-play" aria-label={`Lire ${mix.title}`} onClick={playNow}>
          {busy ? "…" : "▶"}
        </button>
      </div>
      <div className="mix-card-sub">
        {mix.kind === "daylist" ? "Ta playlist du moment, au fil de la journée" : mix.subtitle}
      </div>
    </Link>
  );
}
